import { Link } from 'react-router-dom'
import {Tag} from 'lucide-react'

export default function Footer() {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="bg-gray-50 border-t border-gray-200 mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand */}
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <Tag className="w-8 h-8 text-green-600" />
              <span className="text-xl font-bold bg-gradient-to-r from-green-600 to-blue-600 bg-clip-text text-transparent">
                GlenCode
              </span>
            </Link>
            <p className="text-gray-600 text-sm">
              Your trusted source for Glen Ivy Hot Springs coupons, Costco deals, and exclusive promo codes.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-gray-900 mb-4">Quick Links</h3>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-gray-600 hover:text-green-600 text-sm transition">
                Home
              </Link>
              <Link to="/glen-ivy-guide" className="text-gray-600 hover:text-green-600 text-sm transition">
                Glen Ivy Guide
              </Link>
              <Link to="/blog" className="text-gray-600 hover:text-green-600 text-sm transition">
                Blog
              </Link>
            </div>
          </div>

          {/* Legal */}
          <div>
            <h3 className="font-semibold text-gray-900 mb-4">Legal</h3>
            <p className="text-gray-600 text-xs leading-relaxed">
              <strong>Affiliate Disclosure:</strong> GlenCode.com is a participant in various affiliate marketing programs. 
              We may earn a commission when you click on or make purchases via links on our site. This comes at no extra cost to you. 
              We only recommend products and services we genuinely believe will add value to our readers.
            </p>
          </div>
        </div>

        <div className="border-t border-gray-200 mt-8 pt-8 text-center text-gray-600 text-sm">
          <p>&copy; {currentYear} GlenCode.com. All rights reserved.</p>
        </div>
      </div>
    </footer>
  )
}
